document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action^="/cart/add"]');
  const mocktailVariantId = 50742373024045;

  if (!form) return;

  form.addEventListener('submit', function (e) {
    const checkbox = form.querySelector('#add-mocktail');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const wantsMocktail = checkbox && checkbox.checked;
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    // Let the main product get added normally
    if (!wantsMocktail) return;

    e.preventDefault(); // Stop the default form
    const formData = new FormData(form);

    // Submit the main product first
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(() => {
        // Now add the mocktail with matching quantity
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: mocktailVariantId,
            quantity: quantity,
            properties: {
              'Added via': 'Mocktail checkbox',
            },
          }),
        });
      })
      .then(() => {
        if (window.Shopify && Shopify.theme && Shopify.theme.cart) {
          Shopify.theme.cart.open();
        } else {
          window.location.reload();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
  });
});
